import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { getWorkroomFilteredByIds } from '../../../../../../../reducers';
import { queryParamStringsToIntArray } from '../../../../../../../utils/validationUtils';
import { IconButton } from 'react-toolbox';
import S from 'styles.scss';

const InstallWorkorderHeader = ({ workrooms, printable, resultCount }) => {
  const getWorkroomTitle = () => {
    let title = '';
    workrooms.forEach((w) => {
      if (!title) {
        title = w.name;
      } else {
        title = title.concat(', ', w.name);
      }
    });
    return `${title} Workroom${workrooms.length > 1 ? 's' : ''}`;
  };

  const renderCount = () =>
    <span className={resultCount ? S.resultCount : S.noResult}>
      {resultCount}
    </span>;

  const renderCountHeader = () =>
    <h6 className={S.countHeader}>
      Your search yielded {renderCount()} result{resultCount > 1 ? 's ' : ' '}
      (Click workroom name below to expand/collapse results)
    </h6>;

  return (<header className={cx(S.header, { [S.printable]: printable })}>
    <h4 className={S.title}>{workrooms && getWorkroomTitle()}</h4>
    {renderCountHeader()}
    <IconButton icon="print" className={S.print} onClick={window.print} />
  </header>);
};

InstallWorkorderHeader.propTypes = {
  workrooms: PropTypes.array.isRequired,
  printable: PropTypes.bool.isRequired,
  resultCount: PropTypes.number,
};

InstallWorkorderHeader.defaultProps = {
  printable: true,
  resultCount: 0,
};

export default connect((state, ownProps) => {
  const workrooms = queryParamStringsToIntArray(ownProps.workrooms || []);
  return ({
    workrooms: getWorkroomFilteredByIds(state)(workrooms || []),
  });
})(InstallWorkorderHeader);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/installWorkorderReport/components/InstallWorkorderHeader/index.jsx